import React from 'react';
import { estaCaducado } from '../../lib/helpers/socioEstado';

/**
 * Etiqueta "Caducado" para un socio. No pinta nada si está al día, para no
 * llenar de ruido las listas: lo excepcional es lo que debe verse.
 *
 * Es solo una SEÑAL: no bloquea nada. Bloquear el check-in de los caducados es
 * endurecer un acceso y va por el camino largo (flag apagado + observación),
 * porque muchos socios migrados arrastran caducidades viejas y activarlo a
 * ciegas dejaría media base fuera en plena barra.
 */
const CaducadoChip = ({ socio, className = '' }) => {
  if (!estaCaducado(socio)) return null;
  return (
    <span
      title="La membresía caducó — conviene renovarla"
      className={`inline-flex shrink-0 items-center rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800 ${className}`}
    >
      Caducado
    </span>
  );
};

export default CaducadoChip;
